import React, { Component } from 'react';
import {
  Modal, Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import { pNotification } from './../../../API/FetchCall';

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: localStorage.getItem("authentication") ? localStorage.getItem("authentication") : false,
      auth_data: localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : {},
      isPartner: false,
      showNotifi: false,
      notification_list: []
    };
    this.getNotification();
  }
  componentDidMount() {

  }
  getNotification = () => {
    let req = JSON.stringify({
      role: 4,
      partner_id: this.state.auth_data.partner_id,
      url: 'get_pnotification'
    });
    pNotification(req).then(res => {
      if (res.status === 1) {
        this.setState({
          notification_list: res.list
        })
      }
    })
  }
  dimissNotif = (index) => {
    let notification_list = this.state.notification_list;
    notification_list[index].is_read = 0;
    this.setState({
      notification_list
    })
    let req = JSON.stringify({
      role: 4,
      noti_id: notification_list[index].id,
      url: 'read_notif'
    });
    pNotification(req);
  }
  render() {
    let count = this.state.notification_list.filter(item => item.is_read == 1).length;
    return (
      <React.Fragment>
        <div className='noti-sec'>

          <Dropdown direction={'left'} isOpen={this.state.showNotifi}>
            <DropdownToggle
              data-toggle="dropdown"
              tag="span"
            >
              <div className='pointer' >
                <i class="fa fa-bell" aria-hidden="true"></i> {count > 0 && <span className='noti-count'>{count}</span>}
              </div>

            </DropdownToggle>
            <DropdownMenu className='noti-drop-sec' container="body">
              {count > 0 ?
                this.state.notification_list.map((item, i) => {
                  if (item.is_read == 1)
                    return (
                      <DropdownItem className='noti-list' >
                        {item.text}
                        <span className='pull-right' onClick={() => this.dimissNotif(i)}>
                          <i class="fa fa-times pl-5" aria-hidden="true"></i>
                        </span>
                      </DropdownItem>
                    )
                })
                :
                <DropdownItem className='noti-list' >
                  No items Found
                </DropdownItem>
              }
            </DropdownMenu>
          </Dropdown>

        </div>
      </React.Fragment>
    );
  }
}
export { Notification };




// WEBPACK FOOTER //
// ./src/components/bewise/partners/Notification.jsx